import React from 'react'
import styles from '../styles'

const BuildComplianceList = ({ complianceListData }) => {
  const classes = styles()

  return (
    <div className={classes.expansibleContent}>
      <span>{complianceListData
        ? `Encontra-se na "${complianceListData}".`
        : "Não se encontra na Compliance List."}
      </span>
    </div>
  )
}

export default BuildComplianceList
